document.addEventListener('DOMContentLoaded', () => {
  const follower = document.querySelector('.cursor-follower');
  if (!follower || !window.matchMedia('(hover: hover)').matches) return;

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let currentX = mouseX;
  let currentY = mouseY;
  let currentScale = 0.5;
  let hasMoved = false;

  const clickableSelector = 'a, button, input, select, textarea, summary, [role="button"], [tabindex]:not([tabindex="-1"]), [data-cursor-grow]';

  function distanceToRect(x, y, rect) {
    const dx = Math.max(rect.left - x, 0, x - rect.right);
    const dy = Math.max(rect.top - y, 0, y - rect.bottom);
    return Math.hypot(dx, dy);
  }

  function getTargetScale() {
    return [...document.querySelectorAll(clickableSelector)].some((element) => {
      return distanceToRect(mouseX, mouseY, element.getBoundingClientRect()) < 72;
    }) ? 1.5 : 0.5;
  }

  window.addEventListener('mousemove', (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
    if (!hasMoved) {
      hasMoved = true;
      follower.style.opacity = '1';
    }
  });

  function animate() {
    currentX += (mouseX - currentX) * 0.12;
    currentY += (mouseY - currentY) * 0.12;
    currentScale += (getTargetScale() - currentScale) * 0.1;

    follower.style.transform =
      `translate3d(${currentX}px, ${currentY}px, 0) ` +
      `translate3d(-50%, -50%, 0) scale(${currentScale}) rotate(-15deg)`;

    requestAnimationFrame(animate);
  }

  animate();
});
